import React from "react";
import { arrayOf, element, node, string } from "prop-types";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import classNamesMaker from "classnames";
import { LeftArrow } from "#library/components/Carousel/components/LeftArrow";
import { RightArrow } from "#library/components/Carousel/components/RightArrow";
import styles from "./content.module.css";
export var Content = function Content(_ref) {
  var children = _ref.children,
    Header = _ref.Header,
    separatorClassName = _ref.separatorClassName;
  return /*#__PURE__*/React.createElement(ScrollMenu, {
    Header: Header,
    LeftArrow: LeftArrow,
    RightArrow: RightArrow,
    wrapperClassName: styles["jds-content__wrapper"],
    separatorClassName: classNamesMaker(styles["jds-content__separator"], separatorClassName)
  }, children);
};
Content.propTypes = {
  children: arrayOf(node).isRequired,
  Header: element,
  separatorClassName: string
};